import React from "react";
import { Link } from "react-router";

function NoIndustryOnWorkSpace(props) {

  return (
    <React.Fragment>
      <div className="container" data-testid="workspace-industry-notfound">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        {/* Dark pass 2026-09-09 (re-ink only — same bootstrap markup, no DS migration).
            `.alert-danger` + `.bg-white` painted the light-only look (bg-white is !important,
            so it has to go, not be overridden). The `.alert` box stays; the surface/edge/ink
            tokens carry the ground, the heading keeps the error mark via the danger glyph
            token, and links take the accent token. */}
        <div
          className="alert tw-bg-surface tw-border-edge tw-text-ink"
          role="alert"
          data-testid="workspace-industry-notfound-card"
        >
          <h4 className="alert-heading tw-text-tone-danger-glyph" data-testid="workspace-industry-notfound-title">
            No Industry found on the selected workspace!
          </h4>
          <p className="tw-text-ink-secondary">
            Looks like we are unable to find an industry under the selected
            workspace for you or there is no industry associated to the selected
            workspace.
          </p>
          <hr className="tw-bg-edge tw-opacity-100" />
          <p className="mb-0 tw-text-ink-secondary">
            If you are the admin , Please visit admin section and associate few
            industries for the selected workspace or party. Please click&nbsp;
            <Link
              className="tw-text-accent hover:tw-text-accent-hover"
              style={{ cursor: "pointer" }}
              to={"admin/dashboard"}
              data-testid="workspace-industry-notfound-admin-link"
            >
              here
            </Link>
            &nbsp;to got to admin side
          </p>
          <br />
          <p className="mb-0 tw-text-ink-secondary">
            If you are lost , Please click&nbsp;
            <Link to="/login" className="tw-text-accent hover:tw-text-accent-hover" data-testid="workspace-industry-notfound-login-link">here</Link>&nbsp;to login back
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default NoIndustryOnWorkSpace;
